import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { forwardRef, useImperativeHandle } from "react";

const BarcodeDialog = forwardRef((props, ref) => {
  const { visible, onHide, onSave, loading, title } = props;
  const [barcode, setBarcode] = useState("");
  const inputRef = useRef(null);

  useImperativeHandle(ref, () => ({
    clearBarcode: () => {
      setBarcode("");
    },
    focusInput: () => {
      inputRef.current.focus();
    },
  }));

  useEffect(() => {
    if (visible) {
      setBarcode("");
    }
  }, [visible]);

  // useEffect(() => {
  //   if (visible && inputRef.current) {
  //     inputRef.current.focus();
  //   }
  // }, [visible]);

  const handleInputChange = (e) => {
    setBarcode(e.target.value);
  };

  const handleSave = async (event) => {
    if (!loading) {
      onSave(barcode);
    }
  };

  const handleKeyDown = (event) => {
    if (!loading) {
      if (event.key === "Enter") {
        handleSave();
      } else if (event.key === "Escape") {
        onHide();
      }
    }
  };

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Tutup"
        loading={loading}
        icon="pi pi-times"
        outlined
        onClick={onHide}
      />
      {/* <Button
        label="Save"
        loading={loading}
        icon="pi pi-check"
        onClick={handleSave}
      /> */}
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "38rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={title}
      closeOnEscape={false}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
      closable={false}

      // pt={{
      //   closeButton: {
      //     onFocus: (event) => {
      //       inputRef.current.focus();
      //     },
      //   },
      // }}
    >
      <div className="row-start-center w-100 relative h-100 gap-3 pt-2">
        <i className="pi pi-qrcode text-4xl"> </i>
        <InputText
          // disabled={loading}
          readOnly={loading}
          className="text-center"
          autoFocus
          placeholder="Scan Barcode"
          value={barcode}
          onChange={handleInputChange}
          ref={inputRef}
          onKeyDown={handleKeyDown}
        />
      </div>
    </Dialog>
  );
});

export default BarcodeDialog;
